var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoraPermissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 372,
    viewBox: "0 0 401 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.846 1.0147C248.782 7.80169 258.925 71.6924 293.368 105.721C328.263 140.197 401.425 149.21 400.491 198.26C399.555 247.462 327.066 255.081 289.911 287.341C257.83 315.195 243.258 369.157 200.846 371.599C157.956 374.069 133.364 326.37 100.9 298.226C63.8782 266.131 5.94496 247.001 0.899013 198.26C-4.27944 148.239 42.014 110.515 77.8112 75.2017C113.255 40.237 151.555 -5.96425 200.846 1.0147Z",
    fill: "url(#paint0_linear_3307_163200)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3307_163200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.781 61.2833C246.901 39.2792 321.425 105.878 343.893 189.729C360.69 252.414 292.32 291.696 230.927 308.146C165.864 325.58 80.8518 331.413 63.051 264.98C39.8231 178.292 79.8814 84.0319 164.781 61.2833Z",
    fill: "url(#paint1_linear_3307_163200)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.118 252.963C152.4 252.963 124.258 224.228 124.258 188.779C124.258 153.33 152.4 124.594 187.118 124.594C221.835 124.594 249.978 153.33 249.978 188.779C249.978 224.228 221.835 252.963 187.118 252.963ZM187.118 240.126C200.455 240.126 213.246 234.716 222.677 225.087C232.108 215.457 237.406 202.397 237.406 188.779C237.406 175.16 232.108 162.1 222.677 152.471C213.246 142.841 200.455 137.431 187.118 137.431C173.781 137.431 160.99 142.841 151.559 152.471C142.128 162.1 136.83 175.16 136.83 188.779C136.83 202.397 142.128 215.457 151.559 225.087C160.99 234.716 173.781 240.126 187.118 240.126ZM217.863 166.462L165.261 220.171C161.825 217.671 158.821 214.604 156.373 211.095L208.974 157.386C212.41 159.886 215.414 162.953 217.863 166.462Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3307_163200",
    x: 48.5391,
    y: 53.0368,
    width: 305.936,
    height: 278.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3307_163200"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3307_163200",
    result: "effect2_dropShadow_3307_163200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3307_163200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3307_163200",
    x1: 0.5,
    y1: 186,
    x2: 400.5,
    y2: 186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3307_163200",
    x1: 52.0148,
    y1: 223.792,
    x2: 332.857,
    y2: 148.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoraPermissions);
export default __webpack_public_path__ + "static/media/soraPermissions.0c532ed36bd9c38f6e600027b9326c2b.svg";
export { ForwardRef as ReactComponent };